// This file manages global Firestore config flags for the app
import { db } from './firebase';
import { doc, getDoc, setDoc } from 'firebase/firestore';

export async function getSubscriptionLockedFlag() {
  const configRef = doc(db, 'config', 'subscription');
  const snap = await getDoc(configRef);
  return snap.exists() ? !!snap.data().locked : false;
}

export async function setSubscriptionLockedFlag(locked) {
  const configRef = doc(db, 'config', 'subscription');
  await setDoc(configRef, { locked }, { merge: true });
}

// Admit a waitlist user: move them to active subscription and remove from waitlist
export async function admitWaitlistUser({ userId, plan, months = 1 }) {
  // Set user subscription in users collection
  const now = new Date();
  const start = now.toISOString();
  const end = new Date(now.setMonth(now.getMonth() + months)).toISOString();
  await setDoc(doc(db, 'users', userId), {
    subscriptionPlan: plan,
    subscriptionStatus: 'active',
    subscriptionStart: start,
    subscriptionEnd: end,
    waitlistAdmitted: true
  }, { merge: true });
  // Remove from waitlist
  await setDoc(doc(db, 'waitlist', userId), { admitted: true }, { merge: true });
}

